<div class="about-us" id="about-us">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-lg-6 imageSec">
        <!-- TODO: replace with actual about-us.png -->
        <img src="assets/images/png/about-us.png" alt="PUPA staff and community volunteers" loading="lazy" />
      </div>

      <div class="col-12 col-lg-6 contentSec">
        <span class="badge-pill mb-0">{{ 'about_us.badge' | translate }}</span>

        <h2 class="section-title">
          {{ 'about_us.heading_line1' | translate }}<br />
          {{ 'about_us.heading_line2' | translate }}
        </h2>

        <p class="section-desc">{{ 'about_us.paragraph_1' | translate }}</p>
        <p class="section-desc">{{ 'about_us.paragraph_2' | translate }}</p>

        <div class="d-flex flex-wrap gap-4 vision-mission">
          <div class="vm-card vision">
            <div class="vm-icon">
              <img src="assets/images/png/vision.png" alt="our vision">
            </div>
            <h5>{{ 'about_us.vision_title' | translate }}</h5>
            <p>{{ 'about_us.vision_desc' | translate }}</p>
          </div>
          <div class="vm-card mission">
            <div class="vm-icon">
              <img src="assets/images/png/mission.png" alt="our mission">
            </div>
            <h5>{{ 'about_us.mission_title' | translate }}</h5>
            <p>{{ 'about_us.mission_desc' | translate }}</p>
          </div>
        </div>

        <!-- TODO: no dedicated "full story" page exists in the Figma design yet -->
        <button type="button" class="btn btn-danger cta">{{ 'about_us.cta' | translate }}</button>
      </div>
    </div>
  </div>
</div>